import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { getHeaders } from './auth.interceptor.util';
import { Observable } from 'rxjs';
import { AuthService } from '@services';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const auth = inject(AuthService);
  const accessToken: string = auth.getSessionToken();

  const interceptedRequest: HttpRequest<unknown> = req.clone({
    setHeaders: getHeaders(accessToken, req.method, req.url),
    responseType: req.url.includes('download') ? 'blob' : 'json',
  });

  return next(interceptedRequest);
};
